import { ObjectDirective, VNodeDirective } from 'vue'

interface HTMLElementWithClickOutside extends HTMLElement {
  __vueClickOutside__?: (e: MouseEvent) => void
}

const clickOutside: ObjectDirective = {
  inserted(el: HTMLElementWithClickOutside, binding: VNodeDirective) {
    const handler = (e: MouseEvent) => {
      if (!el.contains(e.target as Node)) {
        (binding.value as (e: MouseEvent) => void)(e)
      }
    }
    el.__vueClickOutside__ = handler
    document.addEventListener('mousedown', handler)
  },

  unbind(el: HTMLElementWithClickOutside) {
    if (el.__vueClickOutside__) {
      document.removeEventListener('mousedown', el.__vueClickOutside__)
      delete el.__vueClickOutside__
    }
  }
}

export default clickOutside
